import { useTranslation } from "react-i18next";

export function NavbarSearchButton() {
    const { t } = useTranslation();
    const openSearch = () => window.dispatchEvent(new Event("open-site-search"));
    const isMac = /Mac|iPhone|iPad/i.test(navigator.userAgent);

    return (
        <button
            onClick={openSearch}
            className="flex items-center gap-3 h-[50px] rounded-full hover:bg-[rgba(36,45,41,0.05)] px-12 text-pine"
           
        >
            <span className="text-base font-bold">{t("search")}</span>
            <kbd className="text-xs opacity-40 font-mono">{isMac ? "\u2318" : "Ctrl+"}K</kbd>
        </button>
    );
}
